module.exports = __webpack_public_path__ + "06_short_yellow.021eaa79.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/06_short_yellow.png
// module id = kQOZ
// module chunks = 0